import React from 'react'
import RiderTable from '../../components/riderTable/RiderTable'

const ManageRider = () => {

  return (
    <div className="ta__dashboard">
      <div className="ta__dashboard__breadcrumb">
        <h2 className="f-24">Manage Customers</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item f-18">
              <a href="/" className="text-gray">
                Home
              </a>
            </li>
            <li
              className="breadcrumb-item f-18 text-black active"
              aria-current="page"
            >
              Rider
            </li>
          </ol>
        </nav>
      </div>
      <div className="ta__dashboard__body">
        <div className="ta__dashboard_sort">
          <form action="" className="d-flex flex-wrap">
            <div className="col-md-4 col-sm-6 col-12">
              <div className="form_control">
                <label htmlFor="">Status</label>
                <div className="ta__country_dropdown">
                  <select className="" name="role">
                    <option value="all">All</option>
                    <option value="on-hold">On hold</option>
                    <option value="Pending">Pending</option>
                    <option value="In progress">In progress</option>
                    <option value="Pending Docs">Pending Docs</option>
                    <option value="Processing in progress">
                      Processing in progress
                    </option>
                    <option value="Invalid documents">Invalid documents</option>
                    <option value="Valid documents">Valid documents</option>
                    <option value="Training planned">Training planned</option>
                    <option value="Absent from training">
                      Absent from training
                    </option>
                    <option value="Rejected post approval">
                      Rejected post approval
                    </option>
                    <option value="Sign contract">Sign contract</option>
                    <option value="Rejected">Rejected</option>
                    <option value="Approved">Approved</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
              <div className="form_control">
                <label htmlFor="">Service</label>
                <div className="ta__country_dropdown">
                  <select className="" name="role">
                    <option value="">All</option>
                    <option value="">USA</option>
                    <option value="">India</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-6 col-12">
              <div className="form_control">
                <label htmlFor="">Driver</label>
                <div className="ta__country_dropdown">
                  <select className="" name="role">
                    <option value="">All</option>
                    <option value="">USA</option>
                    <option value="">India</option>
                  </select>
                </div>
              </div>
            </div>        

          </form>
        </div>

        <RiderTable />
      </div>
    </div>
  )
}

export default ManageRider